import React from "react";
import classNames from "classnames";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";

const StockName = ({ name }) => {
  const isDesktop = useIsDesktop();

  return (
    <span
      className={classNames("line-height-100 text-black-5", {
        "text-sm": isDesktop,
        "text-xs": !isDesktop
      })}
    >
      {name}
    </span>
  );
};

export default StockName;
